import { combineReducers } from 'redux';

import currentApplication from './currentApplication';
import landlord from './landlord';
import loadingStatus from './loadingStatus';
import applicationsBrownout from './applicationsBrownout';
import inviteToApplyModal from './inviteToApplyModal';
import currentListing from '../reducers/currentListing';
import screening from '@zg-rentals/screening-js/lib/flux/reducers/screening';
import requestIdVerificationModalIsOpen from './requestIdVerificationModalIsOpen';

const rentalApplication = combineReducers({
  currentApplication,
  landlord,
  loadingStatus,
  currentListing,
  screening,
  applicationsBrownout,
  inviteToApplyModal,
  requestIdVerificationModalIsOpen,
});

export default rentalApplication;
